import Vue from 'vue';
import DataUtils from 'src/utils/data';
import Project from 'src/api/project';
import FormatUtils from 'src/utils/formatters';
import escapeRegExp from 'escape-string-regexp';
export default Vue.extend({
    props: {
        provider: { type: String, default: null }
    },
    data() {
        return {
            isLoading: true,
            surveyList: [],
            searchValue: '',
            maxReturned: null,
            remainingResults: null,
        };
    },
    computed: {
        filteredSurveyList() {
            let list = this.surveyList;
            if (this.searchValue) {
                const reg = new RegExp(escapeRegExp(this.searchValue), 'i');
                list = list.filter(o => o.name.match(reg));
            }
            return list.sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified));
        },
    },
    watch: {
        provider: {
            immediate: true,
            handler() {
                this.loadSurveys();
            }
        }
    },
    methods: {
        truncate: FormatUtils.truncate,
        formatDate: DataUtils.formatDate,
        loadSurveys() {
            if (this.provider !== null) {
                this.isLoading = true;
                Project.getSurveyList(this.provider)
                    .then((response) => {
                    this.surveyList = response.result.elements;
                    this.remainingResults = response.result.remaining_results;
                    this.maxReturned = response.result.max_returned;
                    this.isLoading = false;
                });
            }
        },
        // Handle selection of survey by fetching metadata and emitting event
        selectSurvey(survey) {
            let dimmer = this.$el.querySelector('.rows .dimmer');
            dimmer.classList.add('active');
            Project.getSurveyMetadata(this.provider, survey.id)
                .then((response) => {
                let numResponses = response.result.response_count;
                this.$emit('survey-selected', survey.id, survey.name, numResponses);
            })
                .finally(() => {
                dimmer.classList.remove('active');
            });
        }
    }
});
